export const countryOptionsDe = [
  { label: "Afghanistan", value: 93 },
  { label: "Albanien", value: 355 },
  { label: "Algerien", value: 213 },
  { label: "Andorra", value: 376 },
  { label: "Angola", value: 244 },
  { label: "Antigua und Barbuda", value: 1 },
  { label: "Argentinien", value: 54 },
  { label: "Armenien", value: 374 },
  { label: "Australien", value: 61 },
  { label: "Österreich", value: 43 },
  { label: "Aserbaidschan", value: 994 },
  { label: "Bahamas", value: 1 },
  { label: "Bahrain", value: 973 },
  { label: "Bangladesch", value: 880 },
  { label: "Barbados", value: 1 },
  { label: "Weißrussland", value: 375 },
  { label: "Belgien", value: 32 },
  { label: "Belize", value: 501 },
  { label: "Benin", value: 229 },
  { label: "Bhutan", value: 975 },
  { label: "Bolivien", value: 591 },
  { label: "Bosnien und Herzegowina", value: 387 },
  { label: "Botswana", value: 267 },
  { label: "Brasilien", value: 55 },
  { label: "Brunei", value: 673 },
  { label: "Bulgarien", value: 359 },
  { label: "Burkina Faso", value: 226 },
  { label: "Burundi", value: 257 },
  { label: "Kap Verde", value: 238 },
  { label: "Kambodscha", value: 855 },
  { label: "Kamerun", value: 237 },
  { label: "Kanada", value: 1 },
  { label: "Zentralafrikanische Republik", value: 236 },
  { label: "Tschad", value: 235 },
  { label: "Chile", value: 56 },
  { label: "China", value: 86 },
  { label: "Kolumbien", value: 57 },
  { label: "Komoren", value: 269 },
  { label: "Kongo", value: 242 },
  { label: "Costa Rica", value: 506 },
  { label: "Kroatien", value: 385 },
  { label: "Kuba", value: 53 },
  { label: "Zypern", value: 357 },
  { label: "Tschechien", value: 420 },
  { label: "Dänemark", value: 45 },
  { label: "Dschibuti", value: 253 },
  { label: "Dominica", value: 1 },
  { label: "Dominikanische Republik", value: 1 },
  { label: "Osttimor (Timor-Leste)", value: 670 },
  { label: "Ecuador", value: 593 },
  { label: "Ägypten", value: 20 },
  { label: "El Salvador", value: 503 },
  { label: "Äquatorialguinea", value: 240 },
  { label: "Eritrea", value: 291 },
  { label: "Estland", value: 372 },
  { label: "Eswatini", value: 268 },
  { label: "Äthiopien", value: 251 },
  { label: "Fidschi", value: 679 },
  { label: "Finnland", value: 358 },
  { label: "Frankreich", value: 33 },
  { label: "Gabun", value: 241 },
  { label: "Gambia", value: 220 },
  { label: "Georgien", value: 995 },
  { label: "Deutschland", value: 49 },
  { label: "Ghana", value: 233 },
  { label: "Griechenland", value: 30 },
  { label: "Grenada", value: 1 },
  { label: "Guatemala", value: 502 },
  { label: "Guinea", value: 224 },
  { label: "Guinea-Bissau", value: 245 },
  { label: "Guyana", value: 592 },
  { label: "Haiti", value: 509 },
  { label: "Honduras", value: 504 },
  { label: "Ungarn", value: 36 },
  { label: "Island", value: 354 },
  { label: "Indien", value: 91 },
  { label: "Indonesien", value: 62 },
  { label: "Iran", value: 98 },
  { label: "Irak", value: 964 },
  { label: "Irland", value: 353 },
  { label: "Israel", value: 972 },
  { label: "Italien", value: 39 },
  { label: "Elfenbeinküste", value: 225 },
  { label: "Jamaika", value: 1 },
  { label: "Japan", value: 81 },
  { label: "Jordanien", value: 962 },
  { label: "Kasachstan", value: 7 },
  { label: "Kenia", value: 254 },
  { label: "Kiribati", value: 686 },
  { label: "Nordkorea", value: 850 },
  { label: "Südkorea", value: 82 },
  { label: "Kosovo", value: 383 },
  { label: "Kuwait", value: 965 },
  { label: "Kirgisistan", value: 996 },
  { label: "Laos", value: 856 },
  { label: "Lettland", value: 371 },
  { label: "Libanon", value: 961 },
  { label: "Lesotho", value: 266 },
  { label: "Liberia", value: 231 },
  { label: "Libyen", value: 218 },
  { label: "Liechtenstein", value: 423 },
  { label: "Litauen", value: 370 },
  { label: "Luxemburg", value: 352 },
  { label: "Madagaskar", value: 261 },
  { label: "Malawi", value: 265 },
  { label: "Malaysia", value: 60 },
  { label: "Malediven", value: 960 },
  { label: "Mali", value: 223 },
  { label: "Malta", value: 356 },
  { label: "Marshallinseln", value: 692 },
  { label: "Mauretanien", value: 222 },
  { label: "Mauritius", value: 230 },
  { label: "Mexiko", value: 52 },
  { label: "Mikronesien", value: 691 },
  { label: "Moldawien", value: 373 },
  { label: "Monaco", value: 377 },
  { label: "Mongolei", value: 976 },
  { label: "Montenegro", value: 382 },
  { label: "Marokko", value: 212 },
  { label: "Mosambik", value: 258 },
  { label: "Myanmar (Burma)", value: 95 },
  { label: "Namibia", value: 264 },
  { label: "Nauru", value: 674 },
  { label: "Nepal", value: 977 },
  { label: "Niederlande", value: 31 },
  { label: "Neuseeland", value: 64 },
  { label: "Nicaragua", value: 505 },
  { label: "Niger", value: 227 },
  { label: "Nigeria", value: 234 },
  { label: "Nordmazedonien", value: 389 },
  { label: "Norwegen", value: 47 },
  { label: "Oman", value: 968 },
  { label: "Pakistan", value: 92 },
  { label: "Palau", value: 680 },
  { label: "Panama", value: 507 },
  { label: "Papua-Neuguinea", value: 675 },
  { label: "Paraguay", value: 595 },
  { label: "Peru", value: 51 },
  { label: "Philippinen", value: 63 },
  { label: "Polen", value: 48 },
  { label: "Portugal", value: 351 },
  { label: "Katar", value: 974 },
  { label: "Rumänien", value: 40 },
  { label: "Russland", value: 7 },
  { label: "Ruanda", value: 250 },
  { label: "St. Kitts und Nevis", value: 1 },
  { label: "St. Lucia", value: 1 },
  { label: "St. Vincent und die Grenadinen", value: 1 },
  { label: "Samoa", value: 685 },
  { label: "San Marino", value: 378 },
  { label: "São Tomé und Príncipe", value: 239 },
  { label: "Saudi-Arabien", value: 966 },
  { label: "Senegal", value: 221 },
  { label: "Serbien", value: 381 },
  { label: "Seychellen", value: 248 },
  { label: "Sierra Leone", value: 232 },
  { label: "Singapur", value: 65 },
  { label: "Slowakei", value: 421 },
  { label: "Slowenien", value: 386 },
  { label: "Salomonen", value: 677 },
  { label: "Somalia", value: 252 },
  { label: "Südafrika", value: 27 },
  { label: "Südsudan", value: 211 },
  { label: "Spanien", value: 34 },
  { label: "Sri Lanka", value: 94 },
  { label: "Sudan", value: 249 },
  { label: "Suriname", value: 597 },
  { label: "Schweden", value: 46 },
  { label: "Schweiz", value: 41 },
  { label: "Syrien", value: 963 },
  { label: "Taiwan", value: 886 },
  { label: "Tadschikistan", value: 992 },
  { label: "Tansania", value: 255 },
  { label: "Thailand", value: 66 },
  { label: "Togo", value: 228 },
  { label: "Tonga", value: 676 },
  { label: "Trinidad und Tobago", value: 1 },
  { label: "Tunesien", value: 216 },
  { label: "Türkei", value: 90 },
  { label: "Turkmenistan", value: 993 },
  { label: "Tuvalu", value: 688 },
  { label: "Uganda", value: 256 },
  { label: "Ukraine", value: 380 },
  { label: "Vereinigte Arabische Emirate", value: 971 },
  { label: "Vereinigtes Königreich", value: 44 },
  { label: "Vereinigte Staaten", value: 1 }
]
